import api from '#/configs/api'
import invokeApi from '#/utils/invokeApi'

export function addToList(propertyId: string, listId = 'favorites', workspaceId = 'default') {
  return invokeApi({
    baseUrl: api.baseUrl,
    endpoint: api.workspace.addToList,
    method: 'POST',
    path: { workspaceId, listId },
    body: { propertyId },
    auth: true
  })
}

export function removeFromList(propertyId: string, listId = 'favorites', workspaceId = 'default') {
  return invokeApi({
    baseUrl: api.baseUrl,
    endpoint: api.workspace.removeFromList,
    method: 'DELETE',
    path: { workspaceId, listId },
    body: { propertyId },
    auth: true
  })
}

export function clearList(listId = 'favorites', workspaceId = 'default') {
  return invokeApi({
    baseUrl: api.baseUrl,
    endpoint: api.workspace.clearList,
    method: 'DELETE',
    path: { workspaceId, listId },
    body: { clear: true },
    auth: true
  })
}

export function requestReport(payload: TopHap.Service.RequestReportRequest, workspaceId = 'default') {
  return invokeApi<TopHap.Service.RequestReportResponse>({
    baseUrl: api.baseV5Url,
    endpoint: api.workspace.requestReport,
    method: 'POST',
    path: { workspaceId },
    body: payload,
    auth: true
  })
}

export function getReport(payload: TopHap.Service.GetReportRequest) {
  const { workspaceId, reportId } = payload
  return invokeApi<TopHap.Service.GetReportResponse>({
    baseUrl: api.baseUrl,
    endpoint: api.workspace.getReport,
    method: 'POST',
    path: { workspaceId, reportId },
    body: {}
  }).then(response => response.data)
}
